import { useEffect, useState } from "react";
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { CapacityResponse } from '@features/desks/services/OfficeCapacityService';
import { Moment } from "moment";
import { getUsersInOfficeOn } from '@features/whereabouts/services/Movements';
import { SimpleUserWithLocation } from '@features/whereabouts/models/movements.models';

export function UsersInOffice(office: OfficeEntity, activeDate?: Moment, capacity?: CapacityResponse) {
  const [isLoading, setIsLoading] = useState(false);
  const [usersInOffice, setUsersInOffice] = useState<SimpleUserWithLocation[]>([]);
  const amUsed = capacity?.amUsed;
  const pmUsed = capacity?.pmUsed;

  // Loads for each date, and again when the office's count changes. It's cleared first so another
  // date's list never shows under this date's count, and a response that arrives after a newer
  // request is ignored.
  useEffect(() => {
    setUsersInOffice([]);
    setIsLoading(false);
    if (!activeDate) return;

    let isCurrent = true;
    setIsLoading(true);
    getUsersInOfficeOn(activeDate, office.id)
      .then((resp: SimpleUserWithLocation[]) => {
        if (isCurrent) setUsersInOffice(resp);
      })
      .catch(() => {})
      .finally(() => {
        if (isCurrent) setIsLoading(false);
      });
    return () => {
      isCurrent = false;
    };
  }, [activeDate, office.id, amUsed, pmUsed]);

  return {
    loading: isLoading,
    users: usersInOffice,
  };
}
